import * as React from 'react'
import { useState } from 'react'

interface TwoFactorAuthFormProps {
  otpAttemptLabel: string
  backupCodeLabel: string
  useBackupCodeText: string
  useOtpText: string
}

export default function TwoFactorAuthForm({
  otpAttemptLabel,
  backupCodeLabel,
  useBackupCodeText,
  useOtpText,
}: TwoFactorAuthFormProps) {
  const [showBackupCode, setShowBackupCode] = useState(false)

  const handleToggle = (e: React.MouseEvent) => {
    e.preventDefault()
    setShowBackupCode(!showBackupCode)
  }

  return (
    <>
      {!showBackupCode ? (
        <div className="otp-form">
          <div className="row">
            <label htmlFor="user_otp_attempt" className="login-label col-xs-12 col-sm-3">
              {otpAttemptLabel}
            </label>
            <div className="col-xs-12 col-sm-9">
              <input
                type="text"
                name="user[otp_attempt]"
                id="user_otp_attempt"
                className="login-input form-control mb-3 email-autofocus"
                autoFocus
              />
            </div>
          </div>
        </div>
      ) : (
        <div className="backup-code-form">
          <div className="row">
            <label htmlFor="user_backup_code" className="login-label col-xs-12 col-sm-3">
              {backupCodeLabel}
            </label>
            <div className="col-xs-12 col-sm-9">
              <input
                type="text"
                name="user[backup_code]"
                id="user_backup_code"
                className="login-input form-control mb-3"
                autoFocus
              />
            </div>
          </div>
        </div>
      )}

      <div className="row">
        <div className="col-xs-12 col-sm-9 offset-sm-3">
          <div className="text-center mb-3">
            <a href="#" onClick={handleToggle}>
              {showBackupCode ? useOtpText : useBackupCodeText}
            </a>
          </div>
        </div>
      </div>
    </>
  )
}
